import React from "react";
import {t} from "../../../shared-services/translate";
import styled from "styled-components";

const HeaderPromo = () => {
  return (
    <HeaderPromoContainer>
      <a href={t("info_header.farmy_app_banner.link")}>
        <div className="promo-image"></div>
        <h2>{t("info_header.farmy_app_banner.body")}</h2>
      </a>
    </HeaderPromoContainer>
  );
};

export default HeaderPromo;

const HeaderPromoContainer = styled.div`
  display: none;

  @media (min-width: 1200px) {
    display: inline-block;
    padding-right: 15px;
  }

  a {
    display: flex;
    align-items: center;
  }

  .promo-image {
    display: inline-block;
    height: 29px;
    width: 26px;
    background-image: url('/resources/farmy/images/farmy-mobile-app-icon.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  h2 {
    font-weight: 900;
    font-size: 16.5px;
    margin-bottom: 0;
    margin-left: 7px;
    margin-top: 3px;
  }
`;
